import { Injectable } from '@angular/core';
import { Parse } from 'parse';
import { DreamparseConfig } from './dreamparse.module';

export enum operators {
    EqualTo = '=',
    NotEqualTo = '!=',
    GreatherThan = '>',
    LessThan = '<',
    LessThanOrEqualTo = '<=',
    GreatherThanOrEqualTo = '>=',
    ValueMatches = 'matches',
    ValueStartsWith = 'starts',
    ValueEndsWith = 'ends',
    InArray = 'in',
    NotInArray = '!in',
    Exists = 'exists',
    NotExists = '!exists',
}


// * @example [['name', '=', 'shoe']]
export type EqualTo = '=';
// * @example [['name', '!=', 'boo']]
export type NotEqualTo = '!='
// * @example [['price', '>', '10']]
export type GreatherThan = '>'
// * @example [['age', '<', '30']]
export type LessThan = '<'
// * @example [['size', '<=', '100']]
export type LessThanOrEqualTo = '<='
// * @example [['price', '>=', '12.5']]
export type GreatherThanOrEqualTo = '>='
// * @example [['name', 'in', '["boo", "foo"]']]
export type InArray = 'in'
// * @example [['age', '!in', '[15, 18, 20]']]
export type NotInArray = '!in'
// * @example [['name', 'matches', 'boo']]
export type ValueMatches = 'matches'
// * @example [['name', 'starts', 'Ja']]
export type ValueStartsWith = 'starts'
// * @example [['email', 'ends', '.com']]
export type ValueEndsWith = 'ends'
// * @example [['email', 'exists', true]]
// * @example [['email', 'exists', false]]
export type Exists = 'exists'
// * @example [['email', '!exists', true]]
// * @example [['email', '!exists', false]]
export type NotExists = '!exists'



export type operator = EqualTo | NotEqualTo | GreatherThan | LessThan | GreatherThanOrEqualTo | LessThanOrEqualTo | ValueMatches | ValueStartsWith | ValueEndsWith | InArray | NotInArray


export type SimpleQuery = [string | string[], (EqualTo | NotEqualTo), any] | [string | string[], (GreatherThan | LessThan | GreatherThanOrEqualTo | LessThanOrEqualTo), (number | Date)] | [string | string[], (Exists | NotExists)] | [string | string[], (ValueMatches | ValueStartsWith | ValueEndsWith), string] | [string | string[], (InArray | NotInArray), any[]]

export interface AndQuery {
    and?: [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery]

}

export interface OrQuery {
    or?: [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery]
}

/**
* Parse File Parameters
* @param {string} name Name of the file
* @param {(string | ArrayBuffer)} data The ArrayBuffer (base64) data from the file
* @param {string} type (Optional) Used only to set HTTP Request Header
* @param {object} metadata (Optional) Save in metadata the file important informations
* @example { size: file.size, type: file.type, ... }
* @param {object} tags (Optional) Add usefull tags to the file
* @example { user_id: user.id, description: '', ... }
*/
export interface ParseFile {
    name: string;
    data: string | ArrayBuffer;
    metadata?: object | {
        size?: number;
        type?: string;
        owner?: Parse.User;
    };
    tags?: object;
}

/**
* Query List Params
* @param {string} table - The Class name
* @param {SimpleQuery[]]} where - Array of SimpleQuerys, in the format: ['column', 'opetator' (=, !=, <, >, <=, >=, starts, ends, matchess, in, !in, exists, !exists), value]
* @example [['name', '=', 'shoe'], ['price', 'exists']]
* @param {string} or - Use to build boolean querys starting with or where or values pass to this param
* @param {string} and - Use to build boolean querys starting with or where or values pass to this param
* @param {string} orderBy - the ordering of the results (ascending by default)
* @param {boolean} descending - if the result's order is descending instead of the default
* @param {number} skip - the number of rows to skip
* @param {number} limit - the max number of rows in the result
* @param {string} include - the pointers that you wanna included in the result object. eg 'categories' or '*'
* @param {string} distinct - only results with distinct results for this column
* @param {boolean} count - Include in result the number of elements
*/
export interface GetListQuery {
    table: string;
    where?: SimpleQuery[];
    and?: [SimpleQuery] | [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery];
    or?: [SimpleQuery] | [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery]
    orderBy?: string;
    descending?: boolean;
    skip?: number;
    limit?: number;
    include?: string;
    distinct?: string;
    count?: boolean;
}
/**
* Query Relation Params
* @param {Parse.Object} item - Parse item
* @param {string} relation - The name of the relation column
* @param {SimpleQuery[]]} where - Array of SimpleQuerys, in the format: ['column', 'opetator' (=, !=, <, >, <=, >=, starts, ends, matchess, in, !in, exists, !exists), value]
* @example [['name', '=', 'shoe'], ['price', 'exists']]
* @param {string} or - Use to build boolean querys starting with or where or values pass to this param
* @param {string} and - Use to build boolean querys starting with or where or values pass to this param
* @param {string} orderBy - the ordering of the results (ascending by default)
* @param {boolean} descending - if the result's order is descending instead of the default
* @param {number} skip - the number of rows to skip
* @param {number} limit - the max number of rows in the result
* @param {string} include - the pointers that you wanna included in the result object. eg 'categories' or '*'
* @param {string} distinct - only results with distinct results for this column
* @param {boolean} count - Include in result the number of elements
*/
export interface GetRelationQuery {
    item: Parse.Object;
    relation: string;
    where?: SimpleQuery[];
    and?: [SimpleQuery] | [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery];
    or?: [SimpleQuery] | [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery]
    orderBy?: string;
    descending?: boolean;
    skip?: number;
    limit?: number;
    include?: string;
    distinct?: string;
    count?: boolean;
}
/**
* Query Where Params
* @param {string} table - The Class name
* @param {SimpleQuery[]]} where - Array of SimpleQuerys, in the format: ['column', 'opetator' (=, !=, <, >, <=, >=, starts, ends, matchess, in, !in, exists, !exists), value]
* @example [['name', '=', 'shoe'], ['price', 'exists']]
* @param {string} or - Use to build boolean querys starting with or where or values pass to this param
* @param {string} and - Use to build boolean querys starting with or where or values pass to this param
* @param {string} orderBy - the ordering of the results (ascending by default)
* @param {boolean} descending - if the result's order is descending instead of the default
* @param {string} include - the pointers that you wanna included in the result object. eg 'categories' or '*'
*/
export interface GetWhereQuery {
    table: string;
    where?: SimpleQuery[]
    and?: [SimpleQuery] | [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery];
    or?: [SimpleQuery] | [SimpleQuery | AndQuery | OrQuery, SimpleQuery | AndQuery | OrQuery]
    orderBy?: string;
    descending?: boolean;
    include?: string;
}
/**
* Query Relation Params
* @param {Parse.Object} item - Parse item
* @param {string} relation - The name of the relation column
* @param {Parse.Object} relationItem - Parse.Object to be put on the relation
* @param {Parse.Object[]]} relationItems - Array of Parse.Object to be put on the relation
*/
export interface SetRelationObject {
    item: Parse.Object;
    relation: string;
    relationItem?: Parse.Object;
    relationItems?: Parse.Object[];
}

/**
 * DreamParse Service configurations
 */
@Injectable({
    providedIn: "root"
})
export class DreamparseOptions {
    public serverURL: string;
    public appId: string;
    public masterKey?: string;
}

@Injectable({
    providedIn: 'root'
})
export class Dreamparse {

    public currentUser: Parse.User = null; // usuÃ¡rio logado

    public parentUser = null; // usuÃ¡rio pai (se nÃ£o tiver, Ã© o logado)

    private config: DreamparseConfig;

    constructor(config: DreamparseOptions) {
        if (config) {
            this.config = config;
            Parse.serverURL = config.serverURL;
            Parse.initialize(config.appId);
            if (config.masterKey) {
                Parse.masterKey = config.masterKey;
            }
            this.setUser();
        }
    }

    /**
       * Set the current user
       */
    setUser() {
        this.currentUser = Parse.User.current();

        if (this.currentUser) {
            if (this.currentUser.get('parent')) {
                this.parentUser = this.currentUser.get('parent');
            } else {
                this.parentUser = Parse.User.current();
            }
        }
    }

    /**
     * Returns the current user or null, if is not logged
     * @returns {Parse.User}
     */
    getUser(): Parse.User {
        if (!this.currentUser) {
            this.setUser();
        }

        return this.currentUser;
    }

    /**
     * Returns the Parent user, if exists, or the current otherwise
     * @returns {Parse.User}
     */
    getParentUser(): Parse.User {
        if (!this.currentUser) {
            this.setUser();
        }

        return this.parentUser;
    }

    /**
     * Returns true if the current user is an Parent User
     * @returns {boolean}
     */
    isParent(): boolean {
        if (this.currentUser && this.parentUser) {
            return this.currentUser.id == this.parentUser.id;
        } else {
            return false;
        }
    }

    /**
     * Do the login with email and password
     * @param {string} email
     * @param {string} password
     * @returns {Parse.User} The logged user
     */
    async logIn(email, password) {
        try {
            await Parse.User.logIn(email, password);

            this.setUser();

            return this.currentUser;

        } catch (error) {
            throw error;
        }
    }

    /**
     * Register the user
     * @param {object} params -  In the format {name: 'jon doe', email: 'email@email.com', password: '123', .... }
     * @returns {Parse.User} The new logged user
     */
    async signUp(params) {

        const user = new Parse.User();
        for (const x in params) {
            user.set(x, params[x]);
        }

        try {
            await user.signUp();
            this.currentUser = Parse.User.current();
            return this.currentUser;
            // Hooray! Let them use the app now.
        } catch (error) {
            throw error;
        }
    }

    /**
     * Log the user out from parse
     * @returns {null}
     */
    async logOut() {
        if (this.currentUser) {
            this.updateItem(this.currentUser, { currentOrganization: null });
        }
        this.currentUser = null;
        this.parentUser = null;
        return await Parse.User.logOut();
    }

    /**
     * Send an email to reset the user's password
     * @param {string} email - The user email
     * @returns {boolean} If the request was successful
     */
    async resetPass(email) {
        return await Parse.User.requestPasswordReset(email);
    }

    /**
     * Update the current user's informations
     * @param {object} params - The json object with the params, like: {name: 'jon doe', username: 'jondoe', email: 'email@email.com', password: '123'}
     * @returns {Parse.User} The current logged user, with the new information
     */
    async updateUser(params) {
        try {
            if (this.config.masterKey)
                return await this.currentUser.save(params, { useMasterKey: true });
            return await this.currentUser.save(params);
        } catch (error) {
            throw error;
        }
    }

    /**
     * Create an Object on Parse
     * @param {string} table - The Class name
     * @param {object} params - The json object with the params, like: {name: 'shoe', price: 10.55, units:5, ... }
     * @returns {Parse.Object} The new created Object
     */
    async saveItem(table: string, params: object) {

        const ItemToSave = Parse.Object.extend(table);
        const itemToSave = new ItemToSave();
        if (this.config.masterKey)
            return await itemToSave.save(params, { useMasterKey: true });
        return await itemToSave.save(params);
    }

    async saveItems(table: string, items: object[]) {

        const ItemObj = Parse.Object.extend(table);

        const promises = items.map(async params => {
            const _item = new ItemObj();
            return await _item.save(params);
        });
        return await Promise.all(promises)
    }

    /**
     * Get an Object from Parse by the Id
     * @param {string} table - The Class name
     * @param {number} itemId - The objectId of the object
     * @returns {Parse.Object} The requested object or null
     */
    async getItem(table, itemId) {
        const ItemObj = Parse.Object.extend(table);
        const query = new Parse.Query(ItemObj);
        query.include('*');
        return await query.get(itemId);
    }

    /**
     * Get an Object from Parse with multiples params
     * @property {string} table - The Class name
     * @property {array[sting, operator, any]} where - Array of SimpleQuery
     * @example [['name', '=', 'shoe'], ['price', 'exists', true]]
     * @property {string} orderBy - the ordering of the results (ascending by default)
     * @property {boolean} descending - if the result's order is descending instead of the default
     * @property {string} include - the pointers that you wanna included in the result object. eg 'categories' or '*'
     * @returns {Parse.Object} The requested object or null
     */
    async getWhere(params: GetWhereQuery) {
        const _query = this.buildBooleanQuery(params.table, params.where);

        params.descending && _query.descending(params.orderBy || 'createdAt');

        !params.descending && _query.ascending(params.orderBy || 'createdAt');

        params.include && _query.include(params.include || '*');

        return await _query.first();
    }

    /**
     * Update a Parse Object
     * @param {Parse.Object} item - The Item be update (not the id)
     * @param {object} params - The json object with the params, like: {name: 'shoe', price: 10.55, units:5, ... }
     * @returns {Parse.Object} The saved Object
     */
    async updateItem(item, params) {
        if (this.config.masterKey)
            return await item.save(params, { useMasterKey: true });
        return await item.save(params);
    }

    /**
     * Delete an Object on Parse
     * @param {Parse.Object} item - The Item be destroyed (not the id)
     * @returns {boolean} If the operation was successful
     */
    async deleteItem(item) {
        if (this.config.masterKey)
            return await item.destroy({ useMasterKey: true });
        return await item.destroy();
    }

    private setQuery(_query, where) {

        if (where) {
            where.forEach(param => {
                const _field = param[0];
                const _operator = param[1];
                const _value = param[2] || null;

                switch (_operator) {
                    case operators.EqualTo:
                        _query.equalTo(_field, _value);
                        break;
                    case operators.NotEqualTo:
                        _query.notEqualTo(_field, _value);
                        break;
                    case operators.InArray:
                        _query.containedIn(_field, _value);
                        break;
                    case operators.NotInArray:
                        _query.notContainedIn(_field, _value);
                        break;
                    case operators.LessThan:
                        _query.lessThan(_field, _value);
                        break;
                    case operators.GreatherThan:
                        _query.greaterThan(_field, _value);
                        break;
                    case operators.LessThanOrEqualTo:
                        _query.lessThanOrEqualTo(_field, _value);
                        break;
                    case operators.GreatherThanOrEqualTo:
                        _query.greaterThanOrEqualTo(_field, _value);
                        break;
                    case operators.ValueStartsWith:
                        _query.startsWith(_field, _value);
                        break;
                    case operators.ValueEndsWith:
                        _query.endsWith(_field, _value);
                        break;
                    case operators.ValueMatches:
                        _query.matches(_field, _value);
                        break;
                    case operators.Exists:
                        _query.exits(_field);
                        break;
                    case operators.NotExists:
                        _query.doesNotExist(_field);
                        break;
                }
            });
        }
    }

    // private async buildMatchQuery(table, where) {
    //     const schema = new Parse.Schema(table);
    //     return await schema.get().then(schema => {

    //         where.forEach(([_foreing, _operator, _value]) => {

    //             // Split the relation and the column
    //             const [_field, _foreignField] = _foreing.split('.')

    //             // Get the ralational/pointer table name from parse schema
    //             const _table = schema.fields[_field].targetClass

    //             // Creates a new query for the relational table
    //             const _relationalQuery = new Parse.Query(_table);

    //             // Build the query params
    //             this.setQuery(_relationalQuery, [[_foreignField, _operator, _value]])

    //             const _query = new Parse.Query(table);
    //             // Set the matching query to the main query
    //             _query.matchesQuery(_field, _relationalQuery)
    //         })
    //     })
    // }

    private buildBooleanQuery(table, where) {

        // If the query contains an and operator, call the buildBooleanQuery on the params
        if (where.and) {
            // Return an and query with the two params
            return Parse.Query.and(
                this.buildBooleanQuery(table, where.and[0]), // Call the buildBooleanQuery on the first param to chech it
                this.buildBooleanQuery(table, where.and[1]) // Call the buildBooleanQuery on the second param to chech it
            )
        }

        // If the query contains an or operator, call the buildBooleanQuery on the params
        if (where.or) {
            // Return an or query with the two params
            return Parse.Query.or(
                this.buildBooleanQuery(table, where.or[0]), // Call the buildBooleanQuery on the first param to chech it
                this.buildBooleanQuery(table, where.or[1]) // Call the buildBooleanQuery on the second param to chech it
            )
        }

        // If it gets here, it means the param is a SimpleQuery, than return a symple query build
        let _query = new Parse.Query(table)
        this.setQuery(_query, Array.isArray(where[0]) ? where : [where]);
        return _query;
    }

    /**
     * Query List Params
     * @property {string} table - The Class name
     * @property {SimpleQuery[]]} where - Array of SimpleQuerys, in the format: ['column', 'opetator' (=, !=, <, >, <=, >=, starts, ends, matchess, in, !in, exists, !exists), value]
     * @example [['name', '=', 'shoe'], ['price', 'exists']]
     * @property {string} or - Use to build boolean querys starting with or where or values pass to this param
     * @property {string} and - Use to build boolean querys starting with or where or values pass to this param
     * @property {string} orderBy - the ordering of the results (ascending by default)
     * @property {boolean} descending - if the result's order is descending instead of the default
     * @property {number} skip - the number of rows to skip
     * @property {number} limit - the max number of rows in the result
     * @property {string} include - the pointers that you wanna included in the result object. eg 'categories' or '*'
     * @property {string} distinct - only results with distinct results for this column
     * @property {boolean} count - Include in result the number of elements
     * @returns {Parse.Object[]} The results from the query
    */
    async getList(params: GetListQuery) {
        let _query = new Parse.Query(params.table);

        params.where && this.setQuery(_query, params?.where);

        (params.and || params.or) && (_query = this.buildBooleanQuery(params.table, params))

        params.descending && _query.descending(params.orderBy || 'createdAt');
        
        !params.descending && _query.ascending(params.orderBy || 'createdAt');

        params.skip && _query.skip(params.skip);

        params.limit && _query.limit(params.limit);

        params.count && _query.withCount();

        _query.include(params?.include || '*');

        if (this.config.masterKey)
            return await (params.distinct && _query.distinct(params.distinct)) || (!params.distinct && _query.find({ useMasterKey: true }))

        return await (params.distinct && _query.distinct(params.distinct)) || (!params.distinct && _query.find())

    }

    /**
     * Get the number of items on this Class
     * @param {string} table - The Class name
     * @param {SimpleQuery[]]} where - Array of SimpleQuerys, in the format: ['column', 'opetator' (=, !=, <, >, <=, >=, starts, ends, matchess, in, !in, exists, !exists), value]
     * @example [['name', '=', 'shoe'], ['price', 'exists']]
     * @returns {number} Number of items
     */
    async count(table, where = null) {
        const _query = new Parse.Query(table);
        where && this.setQuery(_query, where)
        if (this.config.masterKey)
            return await _query.count({ useMasterKey: true });
        return await _query.count();
    }

    /**
     * Get a query results from a relation on a Object
    * @property {Parse.Object} item - Parse item
    * @property {string} relation - The name of the relation column
    * @property {SimpleQuery[]]} where - Array of SimpleQuerys, in the format: ['column', 'opetator' (=, !=, <, >, <=, >=, starts, ends, matchess, in, !in, exists, !exists), value]
    * @example [['name', '=', 'shoe'], ['price', 'exists']]
    * @property {string} or - Use to build boolean querys starting with or where or values pass to this param
    * @property {string} and - Use to build boolean querys starting with or where or values pass to this param
    * @property {string} orderBy - the ordering of the results (ascending by default)
    * @property {boolean} descending - if the result's order is descending instead of the default
    * @property {number} skip - the number of rows to skip
    * @property {number} limit - the max number of rows in the result
    * @property {string} include - the pointers that you wanna included in the result object. eg 'categories' or '*'
    * @property {string} distinct - only results with distinct results for this column
    * @property {boolean} count - Include in result the number of elements
    * @returns { Parse.Object[] } The results from the query
    */
    async getRelation(params: GetRelationQuery) {
        const item = params.item;

        const nrelation = item.relation(params.relation);

        const _query = nrelation.query();

        params.where && this.setQuery(_query, params?.where)

        _query.include(params?.include || '*')

        params.descending && _query.descending(params.orderBy || 'createdAt');

        !params.descending && _query.ascending(params.orderBy || 'createdAt');

        params.include && _query.include(params.include);

        params.skip && _query.skip(params.skip);

        params.limit && _query.limit(params.limit);

        params.count && _query.withCount();
        if (this.config.masterKey)
            return await (params.distinct && _query.distinct(params.distinct)) || (!params.distinct && _query.find({ useMasterKey: true }))
        return await (params.distinct && _query.distinct(params.distinct)) || (!params.distinct && _query.find())
    }
    /**
     * Put a new Relation in the object
     * @propety {Parse.Object} item - Parse item
     * @propety {string} relation - The name of the relation column
     * @propety {Parse.Object} relationItem - Parse.Object to be put on the relation
     * @propety {Parse.Object[]]} relationItems - Array of Parse.Object to be put on the relation
     * @returns { Parse.Object} The results from the query
     */
    async putRelation(params: SetRelationObject) {
        try {
            const _relation = params.item.relation(params.relation);

            params.relationItem && _relation.add(params.relationItem);

            params.relationItems && _relation.add(params.relationItems)

            return await params.item.save();

        } catch (e) {
            throw e;
        }
    }

    /**
     * Put a new Relation in the object
     * @propety {Parse.Object} item - Parse item
     * @propety {string} relation - The name of the relation column
     * @propety {Parse.Object} relationItem - Parse.Object to be put on the relation
     * @propety {Parse.Object[]]} relationItems - Array of Parse.Object to be put on the relation
     * @returns { Parse.Object} The results from the query
     */
    async removeRelation(params: SetRelationObject) {
        try {
            const _relation = params.item.relation(params.relation);

            params.relationItem && _relation.remove(params.relationItem);

            params.relationItems && params.relationItems.forEach(item => _relation.remove(item))

            return await params.item.save();

        } catch (e) {
            throw e;
        }
    }

    /**
     * Get the Parse Config
     * @returns {object}  object with the configurationattributes
     */
    async getConfig() {
        const conf = await Parse.Config.get();
        return conf.attributes;
    }

    /**
     * Subscribe for livequery on a Object
     * @param {string} table - The Class name
     * @param {string} itemId - The id of the item to be observed
     * @returns {subscription} The parse subscription
     */
    async subscribeItem(table, itemId) {
        const query = new Parse.Query(table);
        query.equalTo('objectId', itemId);
        return await query.subscribe();
    }

    /**
     * Subscribe to a query
     * @property {string} table - The Class name
     * @property {SimpleQuery[]]} where - Array of SimpleQuerys, in the format: ['column', 'opetator' (=, !=, <, >, <=, >=, starts, ends, matchess, in, !in, exists, !exists), value]
     * @example [['name', '=', 'shoe'], ['price', 'exists']]
     * @property {string} or - Use to build boolean querys starting with or where or values pass to this param
     * @property {string} and - Use to build boolean querys starting with or where or values pass to this param
     * @property {string} orderBy - the ordering of the results (ascending by default)
     * @property {boolean} descending - if the result's order is descending instead of the default
     * @property {number} skip - the number of rows to skip
     * @property {number} limit - the max number of rows in the result
     * @property {string} include - the pointers that you wanna included in the result object. eg 'categories' or '*'
     * @property {string} distinct - only results with distinct results for this column
     * @property {boolean} count - Include in result the number of elements
     * @returns {subscription} The results from the query
    */
    async subscribeQuery(params: GetListQuery) {
        let _query = new Parse.Query(params.table);

        params.where && this.setQuery(_query, params?.where)

        params.and && (_query = Parse.Query.and(_query, this.buildBooleanQuery(params.table, params)))

        params.or && (_query = Parse.Query.or(_query, this.buildBooleanQuery(params.table, params)))

        params.descending && _query.descending(params.orderBy || 'createdAt');

        !params.descending && _query.ascending(params.orderBy || 'createdAt');

        params.include && _query.include(params.include);

        params.skip && _query.skip(params.skip);

        params.limit && _query.limit(params.limit);

        params.count && _query.withCount();

        return await _query.subscribe();
    }

    /**
     * Stop the subscription for livequery on a query or item
     * @param {subscription} subscription - The parse subscription
     * @returns {boolean} The success of the operation
     */
    async unsubscribe(subscription) {
        if (subscription) {
            return await subscription.unsubscribe();
        }
    }

    /**
     * Parse File Parameters    
     * @property {string} name Name of the file
     * @property {(string | ArrayBuffer)} data The ArrayBuffer (base64) data from the file
     * @property {string} type (Optional) Used only to set HTTP Request Header
     * @property {object} metadata (Optional) Save in metadata the file important informations
     * @example { size: file.size, type: file.type, ... }
     * @property {object} tags (Optional) Add usefull tags to the file
     * @example { user_id: user.id, description: '', ... }
     * @returns {Parse.Object} The created file
     */
    async saveFile(file: ParseFile): Promise<any> {
        const _file = {
            original: file,
            parseFile: new Parse.File(file.name, { base64: file.data }, null, file?.metadata, file?.tags)
        }

        await _file.parseFile.save();

        return _file
    }

    /**
     * Parse File Parameters    
     * @property {string} name Name of the file
     * @property {(string | ArrayBuffer)} data The ArrayBuffer (base64) data from the file
     * @property {string} type (Optional) Used only to set HTTP Request Header
     * @property {object} metadata (Optional) Save in metadata the file important informations
     * @example { size: file.size, type: file.type, ... }
     * @property {object} tags (Optional) Add usefull tags to the file
     * @example { user_id: user.id, description: '', ... }
     * @returns {Parse.Object} The created file
     */
    async saveFiles(files: ParseFile[]): Promise<any> {
        const promises = files.map(async file => {
            const _file = {
                original: file,
                parseFile: new Parse.File(file.name, { base64: file.data }, null, file?.metadata, file?.tags)
            }

            await _file.parseFile.save();

            return _file;
        });
        return await Promise.all(promises)
    }

    /**
     * Calls a Cloud Function
     * @param {string} functionName - The name of the Cloud Function
     * @param {Object} params - the params for the Cloud Function
     * @returns {any} Whatever the Cloud Function returns
     */
    async cloudFunction(functionName, params) {
        return await Parse.Cloud.run(functionName, params);
    }

    /**
     * Loads Parse Class schema
     * @param {string} class_name - The name of the table in parse
     * @returns {Object} - Object with the schema of the class
     */
    async getSchema(class_name) {
        const schema = new Parse.Schema(class_name);
        return await schema.get();
    }

    isSelf(user) {
        return user?.id === this.currentUser.id;
    }

    isAdmin(user) {
        return user.get('admin');
    }

    createParseObject(className) {
        return new Parse.Object(className);
    }

    async saveParseObject(object) {
        return await object.save();
    }
}
